var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"context"},[_c('img',{attrs:{"src":require("../assets/images/not_found.png")}}),_vm._v(" "),_c('p',[_vm._v("您访问的页面不存在...")]),_vm._v(" "),_c('div',[_c('router-link',{attrs:{"to":{path: '/'}}},[_c('el-button',{attrs:{"type":"primary"}},[_vm._v("返回首页")])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16a19be0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/404.vue
// module id = null
// module chunks = 